import Auth from './auth';
import User from './user';
import News from './news';
import Cards from './cards';

export class ClompApi {
    auth = new Auth();
    user = new User();
    news = new News();
    cards = new Cards();
}
